import React from "react";
import "./ComingSoon.css"; // Custom styles
import HeaderOne from '../components/Partials/Headers/HeaderOne';
import Footer from '../components/Partials/Footers/HomeFour/Footer';
const ComingSoon = () => {
  return (
    <>
    <HeaderOne/>
    <div className="coming-soon-bg d-flex align-items-center justify-content-center text-center text-white">
      <div className=" bg-opacity-75 p-5 rounded shadow-lg">
        <h1 className="display-4 fw-bold mb-3 text-white">🚀 Coming Soon</h1>
        <p className="lead mb-4">We're building something amazing. Stay tuned for the launch!</p>
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default ComingSoon;
